import React from 'react';
import { TextField, Typography, Box, Button, Snackbar, Alert, Paper, Grid } from '@mui/material';
import { useValoracionForm } from '../hooks/useValoracionForm';

const FuerzaMiembrosSuperiores = ({ idPaciente }) => {
  const {
    medicionesDerecha,
    medicionesIzquierda,
    mediaDerecha,
    mediaIzquierda,
    maxDerecha,
    maxIzquierda,
    openGood,
    openError,
    setOpenGood,
    setOpenError,
    setMedicionDerecha,
    setMedicionIzquierda,
    calcularResultados,
    guardarDatos,
  } = useValoracionForm({ idPaciente });

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Paper sx={{ width: '100%', p: { xs: 2, md: 3 }, borderRadius: 4, border: '1px solid #dbe7f3' }} elevation={0}>
        <Typography variant="h4" sx={{ textAlign: 'center', color: '#0f172a', fontWeight: 700, mb: 2 }}>
          Fuerza de los miembros superiores
        </Typography>
        <Typography sx={{ textAlign: 'center', color: '#475569', mb: 4 }}>
          Registro de dinamometría bilateral para seguimiento funcional.
        </Typography>

        <TextField label="ID del paciente" variant="outlined" sx={{ mb: 4 }} value={idPaciente} disabled />

        <Typography variant="h6" sx={{ mb: 2 }}>
          Dinamómetro de mano (codo a 90°)
        </Typography>

        {[0, 1, 2].map((index) => (
          <Grid container spacing={2} sx={{ mb: 1.5 }} key={`medicion-${index}`}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label={`Derecha ${index + 1} (kg)`}
                value={medicionesDerecha[index]}
                onChange={(e) => setMedicionDerecha(index, e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label={`Izquierda ${index + 1} (kg)`}
                value={medicionesIzquierda[index]}
                onChange={(e) => setMedicionIzquierda(index, e.target.value)}
              />
            </Grid>
          </Grid>
        ))}

        <Button variant="contained" color="secondary" onClick={calcularResultados} sx={{ mt: 1, mb: 3 }}>
          Calcular resultados
        </Button>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Media derecha (kg)" value={mediaDerecha} disabled />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Media izquierda (kg)" value={mediaIzquierda} disabled />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Pico derecha (kg)" value={maxDerecha} disabled />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Pico izquierda (kg)" value={maxIzquierda} disabled />
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Button variant="contained" color="primary" onClick={guardarDatos}>
            Guardar datos
          </Button>
        </Box>

        <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}>
          <Alert severity="success" onClose={() => setOpenGood(false)}>¡Datos guardados correctamente!</Alert>
        </Snackbar>
        <Snackbar open={openError} autoHideDuration={2000} onClose={() => setOpenError(false)}>
          <Alert severity="error" onClose={() => setOpenError(false)}>Error al guardar los datos.</Alert>
        </Snackbar>
      </Paper>
    </Box>
  );
};

export default FuerzaMiembrosSuperiores;
